module.exports = __webpack_public_path__ + "img/img20.e1b828e1.svg";